import React, { Suspense, lazy } from 'react';
import './brochureCache'; // triggers background PDF fetch immediately on app load
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';
import Home from './pages/Home';
import PageTracking from './tracking/PageTracking';

// Lazy load pages for better performance (Route-based code splitting)
const Features = lazy(() => import('./pages/Features'));
const HowItWorks = lazy(() => import('./pages/HowItWorks'));
const ScheduleDemo = lazy(() => import('./pages/ScheduleDemo'));
const Security = lazy(() => import('./pages/Security'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Brochure = lazy(() => import('./pages/Brochure'));
const HowWeWork = lazy(() => import('./pages/HowWeWork'));

function App() {
  return (
    <div className="App bg-primary min-h-screen flex flex-col text-white">
      <PageTracking />
      <Navbar />
      <div className="flex-grow">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/schedule-demo" element={<ScheduleDemo />} />
            <Route path="/security" element={<Security />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/how-we-engage" element={<HowWeWork />} />
            <Route path="/brochure" element={<Brochure />} />
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </div>
  );
}

export default App;
